module.exports = __webpack_public_path__ + "images/brake.56ce912e65967c19340dff8a55b01e51.png";